import * as React from "react";
import { Toggle as AtlasToggle } from "@wellsky/atlas-ui-react";

interface ToggleProps
  extends Omit<React.ComponentProps<typeof AtlasToggle>, "onChange"> {
  onCheckedChange?: (checked: boolean) => void;
}

function Toggle({ className, onCheckedChange, ...props }: ToggleProps) {
  // NETSOL-11843: `mds-toggle` (applied to the Atlas root) lets index.css
  // restore the app font stack on the label. Atlas renders the label in a bare
  // `Roboto` with no generic fallback, which shows as serif in the widget's
  // shadow root where the Google Fonts @import doesn't load.
  const mergedClassName = ["mds-toggle", className].filter(Boolean).join(" ");
  return (
    <AtlasToggle
      data-slot="toggle"
      className={mergedClassName}
      onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
        onCheckedChange?.(e.target.checked);
      }}
      {...props}
    />
  );
}

export { Toggle };
